<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Bubbles',
  computed: {
     ...mapGetters({
      showBubbles: 'Interface/showBubbles'
    }),
  },
}
</script>

<template>
  <div class='bubbles-wrapper'>
    <div :class="['top', {'-hide': !showBubbles}]"><img src="/assets/ui/bulle.png" class='image' /></div>
    <div :class="['bottom', {'-hide': !showBubbles}]"><img src="/assets/ui/bulle.png" class='image' /></div>  
  </div>
</template>

<style scoped lang="scss">
.bubbles-wrapper {
  @include landscape {
    display: none;
  }
}

.top, .bottom {
  position: fixed;
  width: 100%;
  height: 15%;
  pointer-events: none;
  z-index: $z-index-bubble;
  transition: all 1s ease-out;
  opacity: 1;

  &.-hide {
    opacity: 0;
    transition: all 1s ease-out;
  }
  
  .image {
    width: 100%;
    height: 100%;
  }
}

.top {
  transform: scaleY(-1);
}

.bottom {
  bottom: 0px;
}
</style>
